<template>
    <div>
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: "legalActivities"
    }
</script>

<style scoped>

</style>
